var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * A confirmacao de bloquear, liberar ou remover uma empresa.
 *
 * O dialogo mostra a empresa INTEIRA antes de perguntar, como o
 * `modalActiveCompany.tsx` da referencia faz: quem vai bloquear um acesso confere o
 * CNPJ e o contato na propria pergunta.
 */
let CompanyConfirmScope = class CompanyConfirmScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = '';
        this.question = '';
        this.confirmLabel = 'Confirmar';
        this.busy = false;
        /** Qual icone o titulo leva - `block` para bloquear, `delete` para remover. */
        this.kind = 'block';
        /** O que a acao faz, dito antes de a pessoa confirmar. */
        this.explanation = '';
        /**
         * As tentativas de entrar no painel feitas durante o bloqueio - so ao LIBERAR.
         *
         * E o momento em que elas interessam ao administrador geral: quem tentou, e quando,
         * enquanto a empresa estava bloqueada.
         */
        this.attempts = [];
        this.loadingAttempts = false;
        this.cnpj = '';
        this.razaoSocial = '';
        this.nomeFantasia = '';
        this.ramoAtividade = '';
        this.contactName = '';
        this.contactPhone = '';
        this.contactEmail = '';
        this.onConfirm = Scope.ASYNC_ACTION;
        this.onClose = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "question", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "confirmLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "busy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyConfirmScope.prototype, "kind", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "explanation", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyConfirmScope.prototype, "attempts", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "loadingAttempts", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "cnpj", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "razaoSocial", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "nomeFantasia", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "ramoAtividade", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "contactName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "contactPhone", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyConfirmScope.prototype, "contactEmail", void 0);
CompanyConfirmScope = __decorate([
    Observable
], CompanyConfirmScope);
export { CompanyConfirmScope };
//# sourceMappingURL=company-confirm.scope.js.map